module.exports = __webpack_public_path__ + "img/dec-letter-right.60fabed9.png";